// 埋点
import parse from 'url-parse'
import { capitalize } from 'lodash-es'
import { REGION } from '@ms/config/app'
import { mstrace } from '@ms/utils/trace'
import cookie from '@ms/utils/cookie.js'
import xfetch from '@ms/fetch'
import { tryTellAppRegSuccess } from 'wap/hybrid'
import { getOperId } from 'composables/useRegion.js'
import { apiMoney } from '@ms/utils-es/math'
import { trackOperaReg } from './opera'

// 上报 user id
export const trackUserId = () => {
  const userId = cookie.get('userId')
  if (userId) {
    window.dataLayer.push({ user_id: userId })
  }
}

// 欺诈警示埋点
export const trackSecurity = (phone = '') => {
  const { from } = parse(location.href, true).query
  const key = 'security_warning'
  // 来自欺诈警示页
  if (from === key) {
    mstrace(key, key, {
      eventLabel: phone
    })
  }
}

// 市场渠道追踪
export const traceKol = (shareUrl = '') => {
  const { query } = parse(location.href, true)
  if (query.from && /^lkol/i.test(query.from)) {
    const devider = shareUrl.indexOf('?') === -1 ? '?' : '&'
    shareUrl += `${devider}from=${query.from}`
  }
  return shareUrl
}

// 注册成功埋点
export const traceRegisterSuccess = () => {
  tryTellAppRegSuccess()
  const userId = cookie.get('userId') || ''
  mstrace('registercomplete', 'Reg', {
    href: location.href,
    user_id: userId
  })

  trackOperaReg()
}

// 上报Mixpanel事件 Click Top Up Now
export const traceMixPanelTopup = ({ success, payAmount, bankName, cardBrand, operator, reason }) => {
  const body = {
    userId: cookie.get('userId'),
    operId: getOperId()
  }

  if (REGION === 'ng') {
    const activeTab = document.querySelector('.deposit-tab-nav.active .tab-name')
    body.tabName = activeTab ? activeTab.dataset.name : ''
  } else {
    body.tabName = 'Online Deposit'
  }

  if (success) {
    body.status = 'Success'
  } else {
    body.status = 'Fail'
  }

  payAmount && Object.assign(body, { payAmount: apiMoney(payAmount) })
  bankName && Object.assign(body, { bankName })
  cardBrand && Object.assign(body, { cardBrand: capitalize(cardBrand) })
  operator && Object.assign(body, { operator })
  reason && Object.assign(body, { reason })

  xfetch('/aeroscope/frontend/topup', { method: 'POST', body })
}

// 上报Mixpanel事件 Page View
export const traceMixPanelPageview = ({ pageName }) => {
  const body = {
    userId: cookie.get('userId'),
    operId: Number(getOperId()),
    pageName,
    pagePath: location.pathname,
    pageURL: location.href
  }

  xfetch('/aeroscope/frontend/pageview', { method: 'POST', body })
}

// 上报Mixpanel事件 Register Interact
export const traceMixPanelRegisterInteract = ({ interactionName, pageName }) => {
  const userId = sessionStorage.getItem('reg-userid') || cookie.get('userId')
  const body = {
    userId,
    operId: Number(getOperId()),
    interactionName,
    pageName,
    pagePath: location.pathname,
    pageURL: location.href
  }

  xfetch('/aeroscope/frontend/register/interact', { method: 'POST', body })
}

// 上报Mixpanel事件 Submit KYC
export const traceMixPanelSubmitKyc = ({ pageName, reason, success }) => {
  const body = {
    userId: cookie.get('userId'),
    operId: Number(getOperId()),
    pageName,
    pagePath: location.pathname,
    pageURL: location.href,
    reason
  }

  if (success) {
    body.status = 'Success'
  } else {
    body.status = 'Fail'
  }

  xfetch('/aeroscope/frontend/register/submitkyc', { method: 'POST', body })
}
